import { render, staticRenderFns } from "./LocationItem.vue?vue&type=template&id=5b4449e6&"
import script from "./LocationItem.vue?vue&type=script&lang=js&"
export * from "./LocationItem.vue?vue&type=script&lang=js&"
import style0 from "./LocationItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports